function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export function RightChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "prefix__right-chevron",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.29 9.48a.75.75 0 01.076.948l-.075.091L6.574 17.5 5.5 16.461 11.717 10 5.5 3.54 6.574 2.5l6.717 6.98z",
    id: "prefix__right",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}